/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Services_TitleInputs */

const en_home_services_title = /** @type {(inputs: Home_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive Member Services`)
};

const fr_home_services_title = /** @type {(inputs: Home_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Services exclusifs aux membres`)
};

/**
* | output |
* | --- |
* | "Exclusive Member Services" |
*
* @param {Home_Services_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_services_title = /** @type {((inputs?: Home_Services_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Services_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_services_title(inputs)
	return fr_home_services_title(inputs)
});